module.exports = __webpack_public_path__ + "img/landscape-2.293e8fc9.jpg";